import PropTypes from 'prop-types';
import React from 'react';

function CustomTitle({ hero }) {
  return (
    <>
      {hero.titleStart}{' '}
      <span style={{ color: '#2C78F6' }}>{hero.highlightedTitle}</span>{' '}
      {hero.titleEnd}
    </>
  );
}

CustomTitle.propTypes = {
  hero: PropTypes.shape({
    titleStart: PropTypes.string.isRequired,
    highlightedTitle: PropTypes.string.isRequired,
    titleEnd: PropTypes.string.isRequired,
  }).isRequired,
};

export default CustomTitle;
